import {lazy} from 'react'

const GiftShopSendToFaceScreen = lazy(
  () =>
    import(/* webpackChunkName: 'SendToFace' */ './GiftShopSendToFaceScreen'),
)

export {GiftShopSendToFaceScreen}
export * from './GiftShopSendToFaceScreenParams'
